if($('#pledge-count-header').length) {

    $.post("/wp-admin/admin-ajax.php", {
        'action': 'get_pledge_count',
    }, function (response) {
        if(parseInt(response) > 0) {
            $('#pledge-count-header span').html(response);
        }
    });

}
